'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.listenToWixEvent = listenToWixEvent;
exports.default = _callee2;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WixBridgeActions = require('../actions/WixBridgeActions');

var WixBridgeActions = _interopRequireWildcard(_WixBridgeActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(_callee2);

function listenToWixEvent(event, Wix) {
    return (0, _reduxSaga.eventChannel)(function (emitter) {
        var eventId = Wix.addEventListener(event, function (payload) {
            emitter(payload);
        });

        return function () {
            Wix.removeEventListener(event, eventId);
        };
    });
}

var sagas = [];

sagas.push(function (sagaParams) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var editMode, channel, payload;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            editMode = sagaParams.Wix.Utils.getViewMode();
                            _context.next = 3;
                            return (0, _effects.put)(WixBridgeActions.actions.editModeChange({ editMode: editMode }));

                        case 3:
                            _context.next = 5;
                            return (0, _effects.call)(listenToWixEvent, sagaParams.Wix.Events.EDIT_MODE_CHANGE, sagaParams.Wix);

                        case 5:
                            channel = _context.sent;

                        case 6:
                            if (!true) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 9;
                            return (0, _effects.take)(channel);

                        case 9:
                            payload = _context.sent;
                            _context.next = 12;
                            return (0, _effects.put)(WixBridgeActions.actions.editModeChange(payload));

                        case 12:
                            _context.next = 6;
                            break;

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        })
    );
});

function _callee2(sagaParams) {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return _lodash2.default.map(sagas, function (saga) {
                        return (0, _effects.fork)(saga(sagaParams));
                    });

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked, this);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/sagas/WixBridgeSaga.js
// module id = 478
// module chunks = 0